import * as React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActionArea } from "@mui/material";

const ImgInIcon = styled(Button)(({ theme }) => ({
  position: "absolute",
  top: "105px",
  borderRadius: "20px",
  color: "#ffffff",
  fontSize: "9px",
  textTransform: "none",
  backgroundColor: "rgba(255,255,255,0.16862745098039217 )",
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.16862745098039217 )",
    boxShadow: "none",
  },
  boxShadow: "none",
  padding: "3px",
}));

const SmallIcon = styled(Button)(({ theme }) => ({
  textTransform: "none",
  fontSize: "9px",
  color: "#ffffff",
  borderRadius: "20px",
  backgroundColor: "rgba(255,255,255,0.16862745098039217 )",
  position: "absolute",
  top: "156px",
  left: "85px",
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.16862745098039217 )",
    boxShadow: "none",
  },
  boxShadow: "none",
  padding: "3px",
}));

const TitleText = styled(Typography)(({ theme }) => ({
  color: "#ffffff",
  fontSize: "14px",
  fontWeight: "bold",
}));
const ByText = styled(TitleText)(({ theme }) => ({
  position: "absolute",
  top: "175px",
  color: "#c1c1c1",
}));
const NameText = styled(ByText)(({ theme }) => ({
  left: "35px",
  color: "#36899f",
  fontWeight: "normal",
}));

interface cardsProps {}

// eslint-disable-next-line no-empty-pattern
const Cards: React.FC<cardsProps> = ({}) => {
  const CardImg = require("assets/cardimg1.png");
  return (
    <Card
      sx={{
        borderRadius: "25px",
        width: "138px",
        height: "203px",
        backgroundColor: "rgba(237,237,237,0.10196078431372549)",
      }}
    >
      <CardActionArea>
        <CardMedia
          component="img"
          height="140"
          image={CardImg}
          alt="green iguana"
          sx={{ borderRadius: "25px" }}
        />
        <CardContent>
          <ImgInIcon variant="contained">collector123e</ImgInIcon>
          <TitleText>Deafbeet</TitleText>
          <SmallIcon>$BID</SmallIcon>
          <ByText>by</ByText>
          <NameText>@Althea23</NameText>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default Cards;
